<template>
  <Progressbar v-if="loading" />
  <NetworkError v-else-if="errors" @tryAgain="Auth.getAward()" />
  <div class="flex flex-col w-full" v-else-if="award.title">
    <div class="alert bg-green-custom-4 text-white">
      <span class="mx-auto">{{ award.title }}</span>
    </div>
    <div class="card mt-4 bg-white" v-if="award.winners.length">
      <div class="card-body p-0">
        <div class="overflow-x-auto">
          <table class="table w-full">
            <thead>
              <tr class="odd:bg-yellow-custom-3">
                <th>#</th>
                <th>{{ __('phone number') }}</th>
                <th>{{ __('City') }}</th>
                <th>{{ __('Award type') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="odd:bg-yellow-custom-3" v-for="(item,index) in award.winners">
                <th>{{ index + 1 }}</th>
                <td dir="ltr">{{ item.phone }}</td>
                <td>{{ item.city }}</td>
                <td>
                  <GiftIcon class="w-5 h-5 text-yellow-500 inline-block" />
                  {{ item.prize }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="alert bg-gray-custom-1 mt-3 md:mt-4 text-justify" v-if="award.description">
      <span class="mx-auto text-white" v-html="award.description"></span>
    </div>
  </div>
  <NotFound v-else />
</template>

<script setup>
import Auth from "../../../composables/shop/auth";
import { GiftIcon } from '@heroicons/vue/24/outline'
import { onMounted } from "vue";

const loading = Auth.loading;
const errors = Auth.errors;
const award = Auth.award;
onMounted(() => Auth.getAward())
</script>